/**
 * OrderListContainer
 * --
 *
 */

import React, { useEffect, useState } from 'react';
import OrderList from 'routes/admin.routes/admin.orders/OrderList';
import { useUserStack } from 'store';

/**----------------------------------------
 * [Component] 쇼핑몰관리자: 주문목록 컨테이너
 * ----------------------------------------
 */
const OrderListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();

  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <OrderList
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
          // type="DELIVERY"
        />
      )}
    </>
  );
};

export default OrderListContainer;
